export class ResourceFile {
  constructor({
    id = 0,
    category = null,
    section = null,
    label = null,
    href = null,
  } = {}) {
    this.id = id;
    this.category = category;
    this.section = section;
    this.label = label;
    this.href = href;
  }
}
export function createResourceFile(data) {
  return Object.freeze(new ResourceFile(data));
}
